export default "__VITE_ASSET__BUQSvrwA__"